module.exports = __webpack_public_path__ + "img/ebaoguo-logo.6089f0de.png";